<bit-icon [name]="icon()" class="tw-leading-none" [class.tw-text-lg]="compact()"></bit-icon>
<span #label [class.tw-hidden]="compact()"><ng-content></ng-content></span>
